import LazyLoad from 'vanilla-lazyload';

export default () => {
    new LazyLoad({
        elements_selector: '.lazy-load',
        data_bg: 'src'
    });
};
